<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <div class="grid lg:gap-x-4 grid-cols-1 lg:grid-cols-2">
                    <template
                        v-for="(target,idx) in after.terminateResultDataVoDataList"
                        :key="idx"
                    >
                        <ResultList class="text-base xs:text-lg">
                            <li class="text-gray-900">
                                {{ target.fundCode }}{{ target.fundName }}
                            </li>
                            <li
                                v-if="target.unit !== 0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">贖回(單位數)</span>
                                <span>{{ target.unit }}</span>
                            </li>
                            <li
                                v-if="target.percent !== 0"
                                class="flex items-baseline justify-between"
                            >
                                <span class="text-sm">贖回(比例)</span>
                                <span>{{ target.percent }}%</span>
                            </li>
                            <li class="flex items-baseline justify-between text-gray-700">
                                <span class="text-sm">預估贖回金額({{ policy.currencyText }})</span>
                                <span>{{ addComma(target.amount) }}</span>
                            </li>
                        </ResultList>
                    </template>
                </div>
                <div class="text-right text-gray-900 font-medium text-lg pr-2.5">
                    預估贖回基金總金額({{ policy.currencyText }}) {{ redeemSum }}
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, reactive, computed } from 'vue';
import { addComma } from '@/utils/number/addComma';
import { useStore } from 'vuex';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import Decimal from 'decimal.js';

export default {
    name: 'A7Data',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const store = useStore();
        const policy = computed(() => store.state.policy.policy);
        const data = toRef(props, 'result');
        const after = reactive(data.value.after);
        const code = ref('A7');

        // 轉出金額總和
        const redeemSum = computed(() => {
            let sum = new Decimal(0);
            after.terminateResultDataVoDataList.forEach(i => {
                sum = sum.plus(i.amount);
            });
            return addComma(sum);
        });

        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, after, redeemSum, removeService, addComma, policy };
    },
};
</script>
